import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic
        };
    }
};



// WEBPACK FOOTER //
// ./src/pages/Ccpa/CcpaPage.js